import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CheckAAKeywordInput = {
  label: string
}

export function checkAAKeyword(input: CheckAAKeywordInput) {
  return restApiClient
    .url(
      encodeNestedObject<CheckAAKeywordInput>(
        constructApiUrl(API.aAKeyWords.checkAAKeyword.url, null),
        input
      )
    )
    .get<boolean>()
}
